'use client';

import { Play, Send, Users } from 'lucide-react';
import Link from 'next/link';

import { PinterestIcon } from '@/components/icons/pinterest';
import { socialLinks } from '@/data/social-links';
import config from '@/config';

function FooterSecondaryLink({ href, text }: { href: string; text: string }) {
  return (
    <a
      href={href}
      target="_blank"
      className="text-[#898989] hover:text-white transition-colors text-sm max-xs:text-xs"
    >
      {text}
    </a>
  );
}

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#1B1D22] w-full">
      <div className="mx-auto w-full max-w-[1920px] px-6 py-8">
        <div className="flex flex-col min-[896px]:flex-row justify-between items-start min-[896px]:items-center mb-6">
          {/* Social Media Links */}
          <div className="flex flex-col min-[896px]:flex-row items-start min-[896px]:items-center space-y-4 min-[896px]:space-y-0 min-[896px]:space-x-8 mb-6 min-[896px]:mb-0">
            <Link
              target="_blank"
              href={socialLinks.vk}
              className="flex items-center space-x-2 text-[#a84dff] hover:text-[#971ce6] transition-colors cursor-pointer"
            >
              <Users className="w-5 h-5" />
              <span className="font-medium">ВКонтакте</span>
            </Link>
            <Link
              target="_blank"
              href={socialLinks.youtube}
              className="flex items-center space-x-2 text-[#a84dff] hover:text-[#971ce6] transition-colors cursor-pointer"
            >
              <Play className="w-5 h-5" />
              <span className="font-medium">Youtube</span>
            </Link>
            <Link
              target="_blank"
              href={socialLinks.telegram}
              className="flex items-center space-x-2 text-[#a84dff] hover:text-[#971ce6] transition-colors cursor-pointer"
            >
              <Send className="w-5 h-5" />
              <span className="font-medium">Telegram</span>
            </Link>
            <Link
              target="_blank"
              href={socialLinks.pinterest}
              className="flex items-center space-x-2 text-[#a84dff] hover:text-[#971ce6] transition-colors cursor-pointer"
            >
              <PinterestIcon className="w-5 h-5" />
              <span className="font-medium">Pinterest</span>
            </Link>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-col min-[896px]:flex-row space-y-2 min-[896px]:space-y-0 min-[896px]:space-x-8">
            <Link
              href={'/media'}
              className="text-white hover:text-[#898989] transition-colors max-md:text-sm max-xs:text-xs"
            >
              Медиа
            </Link>
            <Link
              href={'/newauthors'}
              className="text-white hover:text-[#898989] transition-colors max-md:text-sm max-xs:text-xs"
            >
              Авторам
            </Link>
            <Link
              href="/fanfics"
              className="text-white hover:text-[#898989] transition-colors max-md:text-sm max-xs:text-xs"
            >
              Фанфики
            </Link>
            <Link
              href={'/originals'}
              className="text-white hover:text-[#898989] transition-colors max-md:text-sm max-xs:text-xs"
            >
              Ориджиналы
            </Link>
            <Link
              href={socialLinks.about}
              className="text-white hover:text-[#898989] transition-colors max-md:text-sm max-xs:text-xs"
            >
              О нас
            </Link>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-[#25282e] pt-6">
          <div className="space-y-4">
            {/* Legal Links */}
            <div className="flex flex-col min-[896px]:flex-row space-y-2 min-[896px]:space-y-0 min-[896px]:space-x-6">
              <FooterSecondaryLink
                href={`${config.API_URL}/api/v1/documents/terms`}
                text="Условия использования"
              />
              <FooterSecondaryLink
                href={`${config.API_URL}/api/v1/documents/policy`}
                text="Политика конфиденциальности"
              />
              <FooterSecondaryLink href="/map" text="Карта сайта" />
              <FooterSecondaryLink
                href={`${config.API_URL}/api/v1/documents/mediakit`}
                text="Медиа кит"
              />
            </div>
            {/* Copyright */}
            <div className="flex flex-col min-[896px]:flex-row justify-between items-start min-[896px]:items-center gap-2 text-white text-sm max-xs:text-xs">
              <span>© {year} MOLWE, место для твоих историй</span>
              <a
                href="https://mammothdev.by/"
                target="_blank"
                rel="noopener noreferrer"
                className="min-[896px]:ml-auto text-white"
              >
                Powered by Mammoth Dev
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
